import { createFileRoute } from '@tanstack/react-router';
import { CourseStudySHView } from '@/course-study/CourseStudySHView';
import { CourseStudyStudentView } from '@/course-study/CourseStudyStudentView';
import { useCourseStudyAccess } from '~/hooks/useCourseStudyAccess';

export const Route = createFileRoute(
  '/_app/_users/members/$memberId/course-study/',
)({
  component: CourseProgressionScreen,
});

function CourseProgressionScreen() {
  const { memberId } = Route.useParams();
  // The viewer's relation to the student, not `useCurrentUser().isStudyHelper`:
  // as in legacy, the student gets their own Courses screen and every
  // supervisor the Course Progression accordion.
  //
  // The shell renders no `<Outlet/>` until this query resolves with `can_view`,
  // so the answer is already cached here.
  const { access } = useCourseStudyAccess(memberId);
  const studentId = Number(memberId);

  return access?.is_supervisor ? (
    <CourseStudySHView studentId={studentId} />
  ) : (
    <CourseStudyStudentView studentId={studentId} />
  );
}
